import React from 'react';
import { Link } from 'react-router-dom';

import Rodape from '../../components/Rodape';
import Cabecalho from '../../components/cabecalho/Cabecalho';
import Inicio from '../../components/Inicio';
import Contato from '../../components/Contato';
import Indicadores from '../../components/Indicadores';
import Planos from '../../components/Planos';
import Portifolio from '../../components/Portifolio'; // novo import
import '../../estilo.css';

export default class Home extends React.Component {

  constructor(props) {
    super(props);
    this.siteButtons = [
      { titulo: 'SOBRE', href: '#about', action: null },
      { titulo: 'INDICADORES', href: '#indicadores', action: null },
      { titulo: 'PORTFÓLIO', href: '#portfolio', action: null }, // novo botão no menu
      { titulo: 'CONTATO', href: '#contact', action: null },
      { titulo: 'PLANOS', href: '#planos', action: null },
      { titulo: 'CADASTRO', href: '/cadastro', action: null },
      { titulo: 'LOGIN', href: '/login', action: null },
    ];
  }

  render() {
    return (
      <div className="App">
        <Cabecalho buttonList={this.siteButtons} />

        <Inicio />
        <Indicadores />
        <Portifolio />
        <Planos />
        <Contato />
        <Rodape />

        {/* Botão extra de login no final da página (pode manter ou remover se quiser) */}
        <Link to="/login" className="login-button">LOGIN</Link>
      </div>
    );
  }
}
